import { z } from "zod";
export const ProviderKindSchema = z.enum([
    "anthropic",
    "openai",
    "google",
    "ollama",
    "openai_compatible",
]);
export const ProviderSummary = z.object({
    id: z.string().uuid(),
    kind: ProviderKindSchema,
    displayName: z.string(),
    baseUrl: z.string().nullable(),
    enabled: z.boolean(),
    hasApiKey: z.boolean(),
    createdAt: z.string().datetime(),
});
export const TaskResolution = z.object({
    task: z.string(),
    resolved: z.boolean(),
    source: z.enum(["db", "env", "unconfigured"]),
    providerKind: z.string().nullable(),
    providerId: z.string().uuid().nullable(),
    model: z.string().nullable(),
    params: z.record(z.unknown()).nullable(),
});
export const SettingsStatusResponse = z.object({
    providers: z.array(ProviderSummary),
    taskResolutions: z.array(TaskResolution),
    envKeys: z.object({
        anthropic: z.boolean(),
        openai: z.boolean(),
    }),
    encryptionConfigured: z.boolean(),
});
export const ProviderCreateRequest = z.object({
    kind: ProviderKindSchema,
    displayName: z.string().optional(),
    apiKey: z.string().min(1).optional(),
    baseUrl: z.string().optional(),
});
export const ProviderIdParam = z.object({
    id: z.string().uuid(),
});
export const ProviderDeleteResponse = z.object({
    deleted: z.literal(true),
});
export const TaskNameParam = z.object({
    task: z.string().min(1),
});
export const AssignmentUpsertRequest = z.object({
    providerId: z.string().uuid(),
    model: z.string().min(1),
    params: z.record(z.unknown()).optional(),
    maxTokens: z.number().int().positive().optional(),
    temperature: z.number().min(0).max(2).optional(),
});
export const AssignmentSummary = z.object({
    task: z.string(),
    providerId: z.string().uuid(),
    model: z.string(),
    params: z.record(z.unknown()).nullable(),
    maxTokens: z.number().int().nullable(),
    temperature: z.number().nullable(),
});
export const AssignmentClearResponse = z.object({
    cleared: z.literal(true),
});
export const ProviderModel = z.object({
    id: z.string(),
    label: z.string(),
});
export const ProviderModelsResponse = z.object({
    models: z.array(ProviderModel),
});
//# sourceMappingURL=settings.js.map